(function() {
  function mapVariantRow(map, id) {
    if (map == null || id == null || id === '') return undefined;
    return map[id] ?? map[Number(id)] ?? map[String(id)];
  }

  /** product_id sur le variant (JSON Shopify) ; repli si absent */
  function variantProductIdFromEvent(variant) {
    if (!variant) return undefined;
    if (variant.product_id != null) return variant.product_id;
    const vid = variant.id;
    if (vid == null) return undefined;
    const sections = document.querySelectorAll('[data-section-type="product"]');
    for (let i = 0; i < sections.length; i++) {
      const pj = sections[i].querySelector('[data-product-json]');
      if (!pj) continue;
      try {
        const p = JSON.parse(pj.textContent);
        if (p.variants && p.variants.some(function (x) { return String(x.id) === String(vid); })) {
          return p.id;
        }
      } catch (err) {
        continue;
      }
    }
    return undefined;
  }

  /** Console : `window.__DEBUG_HERO_VARIANT__ = true` puis changer de variant */
  function debugHeroVariant(message, data) {
    if (typeof window !== 'undefined' && window.__DEBUG_HERO_VARIANT__ === true) {
      /* Ne pas utiliser `data || ''` : 0 et false seraient affichés comme chaîne vide. */
      if (arguments.length > 1) {
        console.log('[hero-variant]', message, data);
      } else {
        console.log('[hero-variant]', message);
      }
    }
  }

  /** Repère desktop.src / mobile.src d’une slide du JSON hero */
  function extractHeroSlideUrls(slide) {
    if (!slide || typeof slide !== 'object') {
      return { desktop: null, mobile: null };
    }
    const d = slide.desktop && slide.desktop.src ? String(slide.desktop.src) : null;
    const m = slide.mobile && slide.mobile.src ? String(slide.mobile.src) : null;
    return { desktop: d, mobile: m };
  }

  /** Tableau de toutes les URLs du script JSON (une ligne par variant) */
  function debugHeroVariantUrlsEmbedded(rows, heroRootId) {
    if (typeof window === 'undefined' || window.__DEBUG_HERO_VARIANT__ !== true) return;
    if (!Array.isArray(rows)) return;
    const table = rows.map(function (row) {
      const first = row.slides && row.slides[0] ? row.slides[0] : null;
      const urls = extractHeroSlideUrls(first);
      return {
        variant_id: row.variant_id,
        desktop: urls.desktop,
        mobile: urls.mobile,
        slides: row.slides ? row.slides.length : 0,
      };
    });
    debugHeroVariant('URLs embarquées (data-hero-variant-images-json)', {
      heroId: heroRootId || '',
      count: table.length,
    });
    if (typeof console.table === 'function') {
      console.table(table);
    } else {
      console.log(table);
    }
  }

  /**
   * Racines des blocs hero variant pour apply / debug.
   * D’abord [data-hero-variant-images="true"] ; si 0 résultat, repli : script[data-hero-variant-images-json] → ancêtre .index-hero ou #Hero--…
   * (certains DOM n’exposent pas l’attribut sur le conteneur alors que le JSON est bien présent).
   */
  function getHeroVariantRootElements() {
    const primary = document.querySelectorAll('[data-hero-variant-images="true"]');
    if (primary.length) {
      return Array.prototype.slice.call(primary);
    }
    const list = [];
    const seen = new Set();
    document.querySelectorAll('script[data-hero-variant-images-json]').forEach(function (script) {
      const root =
        script.closest('.index-hero') ||
        script.closest('[id^="Hero--"]') ||
        script.closest('.shopify-section') ||
        script.parentElement;
      if (root && !seen.has(root)) {
        seen.add(root);
        list.push(root);
      }
    });
    return list;
  }

  /** Mise à jour médias variant : filtre par product_id sur la racine de section */
  function variantProductScopeAllowsUpdate(root, productIdAttr, variantProductId) {
    const expected = root.getAttribute(productIdAttr);
    if (!expected) return true;
    if (variantProductId == null || variantProductId === '') return false;
    return String(variantProductId) === String(expected);
  }

  /** Parse le JSON embarqué (slideshow / hero) ; null si absent ou invalide */
  function parseVariantImageJsonRows(jsonEl) {
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  /** Ligne JSON + slides pour un variant (évite de dupliquer la construction de map) */
  function getVariantRowAndSlides(rows, variantId) {
    if (!Array.isArray(rows) || rows.length === 0) {
      return { row: undefined, slides: [] };
    }
    const map = Object.create(null);
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (row && row.variant_id != null) {
        map[row.variant_id] = row;
      }
    }
    const row = mapVariantRow(map, variantId);
    const slides = row && Array.isArray(row.slides) ? row.slides : [];
    return { row: row, slides: slides };
  }

  /** Repli vedette produit : même structure que rebuildHero / rebuildSlideshow */
  function featuredFallbackSlide(featuredUrl) {
    return {
      desktop: { src: featuredUrl, alt: '', width: 2400, height: 1600 },
      mobile: null,
    };
  }

  /**
   * Slides prêts pour le build HTML. Si le tableau est vide, `featuredUrl` (souvent data-hero-fallback-image)
   * alimente un repli d’image vedette. Le slideshow passe une chaîne vide (pas de repli vedette côté JS).
   */
  function normalizeVariantSlideList(slides, featuredUrl) {
    let list = Array.isArray(slides) && slides.length ? slides.slice() : [];
    if (!list.length && featuredUrl) {
      list = [featuredFallbackSlide(featuredUrl)];
    }
    return list;
  }

  /** ---------------------------------------------------------------------
   * 🧠 Description: Mise à jour de la description selon le variant actif
   * -------------------------------------------------------------------- */
  function initVariantDescriptionUpdater() {
    const productSections = document.querySelectorAll('[data-section-type="product"]');

    productSections.forEach((section) => {
      const descriptionsJson = section.querySelector('[data-variant-descriptions-json]');
      const tabsJson = section.querySelector('[data-variant-tabs-json]');
      const productMarketingTitleJson = section.querySelector('[data-product-marketing-title-json]');
      const marketingTitleJson = section.querySelector('[data-variant-marketing-title-json]');
      const productJson = section.querySelector('[data-product-json]');
      if (!descriptionsJson || !productJson) return;

      let variantDescriptions = [];
      let variantTabs = [];
      let variantMarketingTitles = [];
      let productMarketingData = null;
      let product = null;

      try {
        variantDescriptions = JSON.parse(descriptionsJson.textContent);
        product = JSON.parse(productJson.textContent);
        if (productMarketingTitleJson) {
          productMarketingData = JSON.parse(productMarketingTitleJson.textContent);
        }
        if (tabsJson) {
          variantTabs = JSON.parse(tabsJson.textContent);
        }
        if (marketingTitleJson) {
          variantMarketingTitles = JSON.parse(marketingTitleJson.textContent);
        }
      } catch (e) {
        console.error('Erreur parsing variant JSON:', e);
        return;
      }

      const descriptionsMap = {};
      variantDescriptions.forEach((item) => {
        descriptionsMap[item.variant_id] = item.description;
      });

      const tabsMap = {};
      variantTabs.forEach((item) => {
        tabsMap[item.variant_id] = {
          instructions: item.instructions || '',
          ingredients: item.ingredients || '',
          attributes: item.attributes || '',
          faq_items: Array.isArray(item.faq_items) ? item.faq_items : []
        };
      });

      const marketingTitleMap = {};
      variantMarketingTitles.forEach(item => {
        marketingTitleMap[item.variant_id] = item.marketing_title;
      });

      const defaultTabContent = {};
      const tabElements = section.querySelectorAll('[data-variant-tab]');
      tabElements.forEach((tabElement) => {
        const tabKey = tabElement.getAttribute('data-variant-tab');
        const toggleEllipsis = tabElement.querySelector('toggle-ellipsis');
        if (toggleEllipsis) {
          const contentElement = toggleEllipsis.querySelector('[data-content]');
          if (contentElement) {
            defaultTabContent[tabKey] = contentElement.innerHTML;
          }
        } else {
          // Cibler tab-content__inner si présent (wrapper défensif SSR),
          // sinon fallback sur le div externe
          const innerWrapper = tabElement.querySelector('.tab-content__inner');
          defaultTabContent[tabKey] = innerWrapper
            ? innerWrapper.innerHTML
            : tabElement.innerHTML;
        }
      });

      function isBlankDescriptionHtml(html) {
        if (html == null || html === '') return true;
        if (typeof html !== 'string') return false;
        // Empty metafield_tag wrappers (e.g. <div class="metafield-rich_text_field"></div>)
        // must not block the product.description fallback.
        return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim() === '';
      }

      function writeDescriptionHtml(container, html) {
        if (!container) return;
        const toggleEllipsis = container.querySelector('toggle-ellipsis');
        if (toggleEllipsis) {
          const contentElement = toggleEllipsis.querySelector('[data-content]');
          if (contentElement) contentElement.innerHTML = html;
          return;
        }
        const inner = container.querySelector('.tab-content__inner');
        if (inner) {
          inner.innerHTML = html;
          return;
        }
        container.innerHTML = html;
      }

      function buildDisplayDescription(variantDescription, productDescription) {
        const variantHTML =
          renderDescription(variantDescription != null ? variantDescription : '') || '';
        const productHTML = renderDescription(productDescription) || '';
        const parts = [];
        // Product (Shopify) description first, then variant metafield — matches Liquid.
        if (!isBlankDescriptionHtml(productHTML)) parts.push(productHTML);
        if (!isBlankDescriptionHtml(variantHTML)) parts.push(variantHTML);
        return parts.join('');
      }

      function updateDescription(variantId) {
        const variantDescription = mapVariantRow(descriptionsMap, variantId);
        const productDescription = product.description || '';
        const displayDescription = buildDisplayDescription(variantDescription, productDescription);

        writeDescriptionHtml(
          section.querySelector('[data-product-description-content]'),
          displayDescription
        );
        writeDescriptionHtml(
          section.querySelector('[data-product-description-tab-content]'),
          displayDescription
        );

        const accordionContents = section.querySelectorAll('[data-product-description-accordion-content]');
        accordionContents.forEach((accordionContent) => {
          const faqAccordion = accordionContent.closest('[data-accordion-uses-variant-faq]');
          if (faqAccordion) {
            const blockId = faqAccordion.getAttribute('data-accordion-block-id');
            const showDescInFaq = faqAccordion.getAttribute('data-accordion-show-description') === 'true';
            const fallbackScript = section.querySelector(`script[data-accordion-fallback-richtext="${blockId}"]`);
            let fallbackText = '';
            if (fallbackScript) {
              try {
                fallbackText = JSON.parse(fallbackScript.textContent);
              } catch (e) {
                fallbackText = '';
              }
            }
            const row = mapVariantRow(tabsMap, variantId);
            const faqItems = row && Array.isArray(row.faq_items) ? row.faq_items : [];
            const tpl = section.querySelector(`template[data-variant-faq-row-template="${blockId}"]`);

            if (faqItems.length > 0 && tpl && tpl.content) {
              accordionContent.innerHTML = '';
              if (showDescInFaq && displayDescription) {
                const intro = document.createElement('div');
                intro.className = 'product-variant-faq__intro rte';
                intro.setAttribute('data-product-accordion-description-intro', '');
                intro.innerHTML = displayDescription;
                accordionContent.appendChild(intro);
              }
              const list = document.createElement('div');
              list.className = 'product-variant-faq__list';
              faqItems.forEach((item) => {
                const frag = tpl.content.cloneNode(true);
                const titleEl = frag.querySelector('.product-variant-faq__title-text');
                const answerEl = frag.querySelector('.product-variant-faq__answer');
                if (titleEl) {
                  titleEl.textContent = item.title || '';
                }
                if (answerEl) {
                  answerEl.innerHTML = renderDescription(item.text);
                }
                const detailsEl = frag.querySelector('details');
                if (detailsEl) {
                  list.appendChild(detailsEl);
                }
              });
              accordionContent.appendChild(list);
            } else {
              const fallbackHtml = renderDescription(fallbackText);
              const combined = showDescInFaq ? displayDescription + fallbackHtml : fallbackHtml;
              const faqFallbackToggleEllipsis = accordionContent.querySelector('toggle-ellipsis');
              if (faqFallbackToggleEllipsis) {
                const contentElement = faqFallbackToggleEllipsis.querySelector('[data-content]');
                if (contentElement) {
                  contentElement.innerHTML = combined;
                }
              } else {
                accordionContent.innerHTML = `<div class="rte">${combined}</div>`;
              }
            }
            return;
          }

          const accordionToggleEllipsis = accordionContent.querySelector('toggle-ellipsis');
          if (accordionToggleEllipsis) {
            const contentElement = accordionToggleEllipsis.querySelector('[data-content]');
            if (contentElement) {
              contentElement.innerHTML = displayDescription;
            }
          } else {
            accordionContent.innerHTML = displayDescription;
          }
        });

        const variantTabsData = mapVariantRow(tabsMap, variantId) || {};
        const tabElements = section.querySelectorAll('[data-variant-tab]');
        tabElements.forEach((tabElement) => {
          const tabKey = tabElement.getAttribute('data-variant-tab');
          const variantTabContent = variantTabsData[tabKey];
          const toggleEllipsis = tabElement.querySelector('toggle-ellipsis');

          // Résolution de la cible d'écriture (par ordre de priorité) :
          // 1. [data-content] dans toggle-ellipsis
          // 2. .tab-content__inner (wrapper défensif SSR)
          // 3. tabElement lui-même (fallback legacy)
          const innerWrapper = !toggleEllipsis
            ? tabElement.querySelector('.tab-content__inner')
            : null;

          function writeContent(html) {
            if (toggleEllipsis) {
              const contentElement = toggleEllipsis.querySelector('[data-content]');
              if (contentElement) contentElement.innerHTML = html;
            } else if (innerWrapper) {
              innerWrapper.innerHTML = html;
            } else {
              tabElement.innerHTML = html;
            }
          }

          if (variantTabContent && variantTabContent !== '') {
            // Contenu variant disponible → mettre à jour
            const tabHtml = renderDescription(variantTabContent);
            if (tabHtml) {
              writeContent(tabHtml);
            } else {
              // renderDescription a retourné '' (format inattendu) :
              // fallback sur le contenu par défaut pour éviter d'afficher
              // le HTML de la variante précédente
              const defaultContent = defaultTabContent[tabKey];
              // undefined = jamais capturé (timing) → ne pas toucher le DOM
              // '' = capturé vide au SSR → écrire vide pour effacer le contenu précédent
              if (defaultContent !== undefined) {
                writeContent(defaultContent);
              }
            }
          } else {
            // Pas de contenu variant → restaurer le contenu par défaut
            const defaultContent = defaultTabContent[tabKey];
            // undefined = jamais capturé (timing) → ne pas toucher le DOM
            // '' = capturé vide au SSR → écrire vide pour effacer le contenu stale
            if (defaultContent !== undefined) {
              writeContent(defaultContent);
            }
          }
        });
      }

      function formatMarketingTitleHtml(value) {
        if (!value) return '';
        const trimmed = String(value).trim();
        if (!trimmed) return '';
        const escaped = document.createElement('div');
        escaped.textContent = trimmed;
        return `<p>${escaped.innerHTML}</p>`;
      }

      function updateMarketingTitle(variantId) {
        const marketingTitle = mapVariantRow(marketingTitleMap, variantId) || '';
        const productMarketingTitle = productMarketingData || '';
        section.querySelectorAll('[data-marketing-title]').forEach((el) => {
          const blockFallback = el.getAttribute('data-marketing-fallback') || '';
          const displayMarketingTitle =
            formatMarketingTitleHtml(marketingTitle) ||
            blockFallback ||
            formatMarketingTitleHtml(productMarketingTitle);
          el.innerHTML = displayMarketingTitle;
        });
      }

      section.addEventListener('theme:variant:change', (event) => {
        if (event.detail?.variant) {
          updateDescription(event.detail.variant.id);
          updateMarketingTitle(event.detail.variant.id);
        }
      });
    });
  }

/** ---------------------------------------------------------------------
 * 🔷 Icons : afficher uniquement celles du variant actif
 * -------------------------------------------------------------------- */
function initVariantIconUpdater() {
  const productSections = document.querySelectorAll('[data-section-type="product"]');

  productSections.forEach((section) => {
    const iconBlocks = section.querySelectorAll('[data-variant-attr]');
    const currentVariantInput = section.querySelector('input[name="id"]');

    if (!iconBlocks.length || !currentVariantInput) return;

    function updateIcons(variantId) {
      iconBlocks.forEach((block) => {
        const isActive = block.dataset.variantAttr === variantId.toString();
        block.classList.toggle('hiddenD', !isActive);
      });
    }

    // Init au chargement
    updateIcons(currentVariantInput.value);

    // Changement de variant
    section.addEventListener('theme:variant:change', (event) => {
      if (event.detail?.variant?.id) {
        updateIcons(event.detail.variant.id);
      }
    });
  });
}


  /** ---------------------------------------------------------------------
   * 🖼 Images : gestion dynamique des médias selon le variant
   * -------------------------------------------------------------------- */
  function initVariantImageUpdater() {
    const productSections = document.querySelectorAll('[data-section-type="product"]');

    /** Toujours re-query le DOM : rebuildSlideshowVariantImages / rebuildHeroVariantImages peuvent remplacer les slides via innerHTML. */
    function applySlidesAndThumbs(section, variantIdStr) {
      const slides = section.querySelectorAll('[data-slide]');
      const thumbItems = section.querySelectorAll('[data-thumb-item][data-variant-id]');
      slides.forEach((slide) => {
        const isCurrent = slide.dataset.variantId === variantIdStr;
        slide.classList.toggle('is-active', isCurrent);
        slide.classList.toggle('hiddenD', !isCurrent);
        /** ZoomImages.refreshImages() exclut les img si l’élément [data-media-id] a `is-hidden` (même nœud que data-slide dans media.liquid). */
        slide.classList.toggle('is-hidden', !isCurrent);
      });

      thumbItems.forEach((thumb) => {
        const isCurrent = thumb.dataset.variantId === variantIdStr;
        thumb.classList.toggle('hiddenD', !isCurrent);
      });
    }

    productSections.forEach((section) => {
      const currentVariantInput = section.querySelector('input[name="id"]');
      const currentVariantId = currentVariantInput?.value;
      const slides = section.querySelectorAll('[data-slide]');
      if (!slides.length || !currentVariantId) return;

      // Init : afficher uniquement les médias / miniatures du variant actif
      applySlidesAndThumbs(section, currentVariantId);

      const firstActive = section.querySelector('.is-active [data-media-id]');
      const productImages = section.querySelector('product-images');
      if (firstActive && productImages?.setActiveMedia) {
        productImages.setActiveMedia(firstActive.dataset.mediaId);
      }
    });

    // Document + enregistrement après initVariantMetafieldSlideshowAndHero : le rebuild metafield doit passer avant,
    // puis on applique les classes sur le DOM à jour (les listeners sur section tourneraient avant le bubble document).
    document.addEventListener('theme:variant:change', (e) => {
      const section = e.target?.closest?.('[data-section-type="product"]');
      if (!section) return;

      const variantId = e.detail?.variant?.id;
      if (!variantId) return;

      if (!section.querySelectorAll('[data-slide]').length) return;

      const variantIdStr = variantId.toString();
      applySlidesAndThumbs(section, variantIdStr);

      let firstMarked = false;
      section.querySelectorAll('[data-slide]').forEach((slide) => {
        const isCurrent = slide.dataset.variantId === variantIdStr;
        if (isCurrent && !firstMarked) {
          slide.classList.add('product__slide--first');
          firstMarked = true;
        } else {
          slide.classList.remove('product__slide--first');
        }
      });
    });
  }

  /** ---------------------------------------------------------------------
   * 📋 Accordion group (template produit) : FAQ métaobjets par variant
   * -------------------------------------------------------------------- */
  function initAccordionGroupVariantFaq() {
    const groups = document.querySelectorAll('[data-section-type="accordion-group-variant-faq"]');
    if (!groups.length) return;

    function syncAccordionGroupHeading(group, show) {
      group.querySelectorAll('[data-accordion-group-heading]').forEach((heading) => {
        heading.hidden = !show;
      });
    }

    function syncAccordionGroupSectionOuter(group) {
      const sectionOuter = group.parentElement;
      if (!sectionOuter) return;
      const root = group.querySelector('[data-accordion-group-variant-faq-root]');
      if (!root) {
        sectionOuter.style.removeProperty('display');
        return;
      }
      const hasVariantFaq = !root.hidden;
      const staticEls = group.querySelectorAll('[data-accordion-group-static-faq-item]');
      const hasVisibleStatic = staticEls.length > 0 && Array.from(staticEls).some((el) => !el.hidden);
      if (hasVariantFaq || hasVisibleStatic) {
        sectionOuter.style.removeProperty('display');
      } else {
        sectionOuter.style.display = 'none';
      }
    }

    function updateAll(variantId, variantProductId) {
      if (variantId == null || variantId === '') return;

      groups.forEach((group) => {
        if (!variantProductScopeAllowsUpdate(group, 'data-accordion-group-product-id', variantProductId)) {
          return;
        }
        const jsonEl = group.querySelector('[data-accordion-group-faq-json]');
        const root = group.querySelector('[data-accordion-group-variant-faq-root]');
        const staticItems = group.querySelectorAll('[data-accordion-group-static-faq-item]');
        if (!jsonEl || !root) return;

        let rows;
        try {
          rows = JSON.parse(jsonEl.textContent);
        } catch (e) {
          return;
        }

        const map = {};
        rows.forEach((item) => {
          map[item.variant_id] = item;
        });

        const row = mapVariantRow(map, variantId);
        const faqItems = row && Array.isArray(row.faq_items) ? row.faq_items : [];
        const sectionId = group.getAttribute('data-section-id');
        const tpl = sectionId
          ? group.querySelector(`template[data-accordion-group-faq-row-template="${sectionId}"]`)
          : null;

        /** show: show theme question blocks; hide when variant metafield FAQ is shown */
        function setStaticFaqVisibility(show) {
          staticItems.forEach((el) => {
            el.hidden = !show;
          });
        }

        const showVariantFaqHeading = faqItems.length > 0;

        if (faqItems.length === 0) {
          root.innerHTML = '';
          root.hidden = true;
          setStaticFaqVisibility(true);
          syncAccordionGroupHeading(group, false);
          syncAccordionGroupSectionOuter(group);
          return;
        }

        if (!tpl || !tpl.content) {
          root.innerHTML = '';
          root.hidden = true;
          setStaticFaqVisibility(true);
          syncAccordionGroupHeading(group, showVariantFaqHeading);
          syncAccordionGroupSectionOuter(group);
          return;
        }

        setStaticFaqVisibility(false);
        root.hidden = false;
        root.innerHTML = '';

        const list = document.createElement('div');
        list.className = 'product-variant-faq__list';
        faqItems.forEach((item) => {
          const frag = tpl.content.cloneNode(true);
          const titleEl = frag.querySelector('.product-variant-faq__title-text');
          const answerEl = frag.querySelector('.product-variant-faq__answer');
          if (titleEl) {
            titleEl.textContent = item.title || '';
          }
          if (answerEl) {
            answerEl.innerHTML = renderDescription(item.text);
          }
          const detailsEl = frag.querySelector('details');
          if (detailsEl) {
            list.appendChild(detailsEl);
          }
        });
        root.appendChild(list);
        syncAccordionGroupHeading(group, showVariantFaqHeading);
        syncAccordionGroupSectionOuter(group);
      });
    }

    document.addEventListener('theme:variant:change', (e) => {
      const v = e.detail?.variant;
      if (!v?.id) return;
      const pid = v.product_id != null ? v.product_id : variantProductIdFromEvent(v);
      updateAll(v.id, pid);
    });

    const idInput = document.querySelector('product-form [name="id"]');
    if (idInput && idInput.value) {
      let initialProductId;
      const productSection = document.querySelector('[data-section-type="product"]');
      if (productSection) {
        const pj = productSection.querySelector('[data-product-json]');
        if (pj) {
          try {
            initialProductId = JSON.parse(pj.textContent).id;
          } catch (err) {
            /* ignore */
          }
        }
      }
      updateAll(idInput.value, initialProductId);
    }
  }

  /**
   * Une seule FAQ variant ouverte à la fois par liste (équivalent single="true" du thème,
   * sans réutiliser data-collapsible sur les <details> imbriqués).
   */
  function initProductVariantFaqExclusive() {
    document.addEventListener(
      'toggle',
      (e) => {
        const details = e.target;
        if (!details || details.nodeName !== 'DETAILS') return;
        if (!details.classList.contains('product-variant-faq__item--native')) return;
        if (!details.open) return;

        const list = details.closest('.product-variant-faq__list');
        if (!list) return;

        list.querySelectorAll('details.product-variant-faq__item--native').forEach((other) => {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
      },
      true
    );
  }

  /** ---------------------------------------------------------------------
   * 🧩 Utilitaires
   * -------------------------------------------------------------------- */
  function renderDescription(displayDescription) {
    if (!displayDescription) return '';
    if (typeof displayDescription === 'string') return displayDescription;
    if (typeof displayDescription === 'object' && displayDescription.type === 'root') {
      return renderRichText(displayDescription);
    }
    return '';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /**
   * Shopify rich text AST (métaobjets / JSON) : texte avec bold/italic sur le nœud « text »,
   * types heading, list, list-item, etc. L’ancienne version ignorait ces types → contenu vide dès qu’un style ou un titre était utilisé.
   */
  function renderRichText(node) {
    if (!node || typeof node !== 'object') return '';
    const children = node.children || [];

    if (node.type === 'root') return children.map(renderRichText).join('');

    if (node.type === 'paragraph') {
      return `<p>${children.map(renderRichText).join('')}</p>`;
    }

    if (node.type === 'heading') {
      const level = Math.min(Math.max(parseInt(node.level, 10) || 2, 1), 6);
      return `<h${level}>${children.map(renderRichText).join('')}</h${level}>`;
    }

    if (node.type === 'list') {
      const tag = node.listType === 'ordered' ? 'ol' : 'ul';
      return `<${tag}>${children.map(renderRichText).join('')}</${tag}>`;
    }

    if (node.type === 'list-item') {
      return `<li>${children.map(renderRichText).join('')}</li>`;
    }

    if (node.type === 'text') {
      let html = escapeHtml(node.value != null ? node.value : '');
      html = html.replace(/\n/g, '<br>');
      if (node.bold && node.italic) {
        html = `<strong><em>${html}</em></strong>`;
      } else if (node.bold) {
        html = `<strong>${html}</strong>`;
      } else if (node.italic) {
        html = `<em>${html}</em>`;
      }
      return html;
    }

    if (node.type === 'bold') {
      return `<strong>${children.map(renderRichText).join('')}</strong>`;
    }

    if (node.type === 'italic') {
      return `<em>${children.map(renderRichText).join('')}</em>`;
    }

    if (node.type === 'link') {
      const href = escapeHtml(node.url || '#');
      const target = node.target === '_blank' ? ' target="_blank" rel="noopener noreferrer"' : '';
      return `<a href="${href}"${target}>${children.map(renderRichText).join('')}</a>`;
    }

    return '';
  }

  /** ---------------------------------------------------------------------
   * 🖼 Slideshow (section) : image_slider1 / 1_mobile / 2 / 2_mobile par variant
   * -------------------------------------------------------------------- */
  function destroySlideshowFlickity(slideshowEl) {
    const tv = window.themeVendor;
    if (!slideshowEl || !tv || !tv.Flickity) return;
    let flkty = null;
    if (typeof tv.Flickity.data === 'function') {
      flkty = tv.Flickity.data(slideshowEl);
    }
    if (!flkty && slideshowEl.flickity) {
      flkty = slideshowEl.flickity;
    }
    if (flkty && typeof flkty.destroy === 'function') {
      flkty.destroy();
    }
  }

  function escapeHtmlAttr(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;');
  }

  /** width/height → ratio largeur/hauteur (aligné sur image-hero / theme.css) */
  function aspectRatioFromDimensions(img) {
    if (!img) return null;
    const w = Number(img.width) || 0;
    const h = Number(img.height) || 0;
    if (w > 0 && h > 0) return (w / h).toFixed(4);
    return null;
  }

  /** Bloc image__hero__frame (même logique que image-hero / slideshow variant). */
  function buildVariantImageHeroFrameInner(slide, dHeight, mHeight) {
    const d = slide.desktop;
    const m = slide.mobile;
    const primary = d && d.src ? d : m;
    if (!primary || !primary.src) return '';

    const w = Number(primary.width) || 2400;
    const h = Number(primary.height) || 1600;
    const alt = escapeHtmlAttr(primary.alt || '');

    const arDesktop = aspectRatioFromDimensions(d) || aspectRatioFromDimensions(m) || '1.5';
    const arFromMobile = m ? aspectRatioFromDimensions(m) : null;
    const arMobile = m && m.src && arFromMobile ? arFromMobile : arDesktop;

    let innerMedia = '';
    if (m && m.src && d && d.src && m.src !== d.src) {
      innerMedia =
        `<picture>` +
        `<source media="(min-width: 750px)" srcset="${escapeHtmlAttr(d.src)}" sizes="100vw" />` +
        `<source media="(max-width: 749px)" srcset="${escapeHtmlAttr(m.src)}" sizes="100vw" />` +
        `<img src="${escapeHtmlAttr(d.src)}" alt="${alt}" width="${w}" height="${h}" loading="lazy" class="is-loading">` +
        `</picture>`;
    } else {
      innerMedia = `<img src="${escapeHtmlAttr((d || m).src)}" alt="${alt}" width="${w}" height="${h}" loading="lazy" class="is-loading">`;
    }

    return (
      `<div class="image__hero__frame ${dHeight} ${mHeight}" style="--aspect-ratio: ${arDesktop};--aspect-ratio-mobile: ${arMobile};">` +
        `<div class="image__hero__pane">` +
          `<div class="image__hero__scale image__fill lazy-image lazy-image--backfill is-loading">` +
            innerMedia +
          `</div>` +
        `</div>` +
      `</div>`
    );
  }

  function buildHeroVariantMountHtml(slide, dHeight, mHeight) {
    const inner = buildVariantImageHeroFrameInner(slide, dHeight, mHeight);
    if (!inner) return '';
    return `<div class="hero__split-image">${inner}</div>`;
  }

  function buildSlideshowVariantSlideFromPair(slide, idx, sectionId, dHeight, mHeight, isSelected) {
    const inner = buildVariantImageHeroFrameInner(slide, dHeight, mHeight);
    if (!inner) return '';

    const sel = isSelected ? ' is-selected' : '';
    return (
      `<div class="slideshow__slide slideshow__slide--${sectionId}-vj${idx} frame wide-image ${dHeight} ${mHeight}${sel}" ` +
        `data-slide="variant-${sectionId}-vj${idx}" data-slide-index="${idx}" data-slide-text-color="">` +
        `<div class="hero__image frame__item">` +
          inner +
        `</div>` +
      `</div>`
    );
  }

  function rebuildHeroVariantImages(root, slides) {
    const mount = root.querySelector('[data-hero-variant-mount]');
    if (!mount) {
      debugHeroVariant('rebuild: pas de [data-hero-variant-mount]', { id: root.id });
      return;
    }

    const dHeight = root.getAttribute('data-hero-desktop-height') || '';
    const mHeight = root.getAttribute('data-hero-mobile-height') || '';
    const featuredUrl = (root.getAttribute('data-hero-fallback-image') || '').trim();
    const list = normalizeVariantSlideList(slides, featuredUrl);
    const usedProductFeaturedFallback =
      Boolean(featuredUrl) && list.length > 0 && (!Array.isArray(slides) || slides.length === 0);

    if (!list.length) {
      if (mount.innerHTML && String(mount.innerHTML).trim() !== '') {
        root.style.removeProperty('display');
        debugHeroVariant('rebuild: 0 slide JSON — on conserve le HTML du mount (repli section / premier rendu)', {
          slideCount: Array.isArray(slides) ? slides.length : 0,
        });
        return;
      }
      root.style.display = 'none';
      debugHeroVariant('rebuild: pas de slide exploitable (JSON + mount vide + pas de repli vedette sur le root)', {
        slideCount: Array.isArray(slides) ? slides.length : 0,
      });
      return;
    }

    const urlsForRebuild = extractHeroSlideUrls(list[0]);
    debugHeroVariant('rebuild: URLs injectées dans le DOM', {
      desktop: urlsForRebuild.desktop,
      mobile: urlsForRebuild.mobile,
      productFeaturedFallback: usedProductFeaturedFallback,
    });

    const html = buildHeroVariantMountHtml(list[0], dHeight, mHeight);
    if (!html) {
      root.style.display = 'none';
      debugHeroVariant('rebuild: buildHeroVariantMountHtml vide', { firstSlide: list[0] });
      return;
    }
    mount.innerHTML = html.trim();
    root.style.removeProperty('display');
    debugHeroVariant('rebuild: OK', { usedProductFeaturedFallback: usedProductFeaturedFallback });
    window.dispatchEvent(new Event('resize'));
  }

  /**
   * Met à jour slideshow + hero variant depuis le JSON embarqué.
   * Le premier theme:variant:change peut partir avant l’enregistrement des listeners (scripts defer) :
   * appeler aussi syncVariantMetafieldImagesFromForm() au chargement.
   */
  function applyVariantMetafieldImages(variantId, variantProductId) {
    if (variantId == null || variantId === '') return;

    document.querySelectorAll('[data-slideshow-variant-images="true"]').forEach(function (root) {
      if (!variantProductScopeAllowsUpdate(root, 'data-slideshow-product-id', variantProductId)) {
        return;
      }
      const jsonEl = root.querySelector('[data-slideshow-variant-images-json]');
      const rows = parseVariantImageJsonRows(jsonEl);
      if (!rows) return;
      const { slides } = getVariantRowAndSlides(rows, variantId);
      rebuildSlideshowVariantImages(root, slides);
    });

    const heroRoots = getHeroVariantRootElements();
    debugHeroVariant('apply: sections hero variant (attribut ou repli script JSON)', heroRoots.length);
    heroRoots.forEach(function (root) {
      if (!variantProductScopeAllowsUpdate(root, 'data-hero-product-id', variantProductId)) {
        const expectedPid = root.getAttribute('data-hero-product-id');
        if (expectedPid && (variantProductId == null || variantProductId === '')) {
          debugHeroVariant('apply: skip — product_id manquant alors que data-hero-product-id est défini', {
            expectedPid: expectedPid,
            variantId: variantId,
          });
        } else if (expectedPid) {
          debugHeroVariant('apply: skip — product_id ne correspond pas au hero', {
            expectedPid: expectedPid,
            variantProductId: variantProductId,
            variantId: variantId,
          });
        }
        return;
      }
      const jsonEl = root.querySelector('[data-hero-variant-images-json]');
      if (!jsonEl) {
        debugHeroVariant('apply: pas de script data-hero-variant-images-json', { id: root.id });
        return;
      }
      const rows = parseVariantImageJsonRows(jsonEl);
      if (!rows) {
        debugHeroVariant('apply: JSON.parse erreur ou vide', { id: root.id });
        return;
      }
      const rowSlides = getVariantRowAndSlides(rows, variantId);
      const row = rowSlides.row;
      const slides = rowSlides.slides;
      debugHeroVariantUrlsEmbedded(rows, root.id);
      const activeUrls = slides.length ? extractHeroSlideUrls(slides[0]) : { desktop: null, mobile: null };
      debugHeroVariant('apply: variant actif → URLs sélectionnées', {
        variantId: variantId,
        variantProductId: variantProductId,
        rowFound: Boolean(row),
        slideCount: slides.length,
        desktop: activeUrls.desktop,
        mobile: activeUrls.mobile,
      });
      rebuildHeroVariantImages(root, slides);
    });
  }

  function initVariantMetafieldSlideshowAndHero() {
    document.addEventListener('theme:variant:change', (e) => {
      const v = e.detail?.variant;
      const pid = v && (v.product_id != null ? v.product_id : variantProductIdFromEvent(v));
      applyVariantMetafieldImages(v?.id, pid);
    });
  }

  function syncVariantMetafieldImagesFromForm() {
    const productSections = document.querySelectorAll('[data-section-type="product"]');
    if (productSections.length) {
      productSections.forEach((section) => {
        const pj = section.querySelector('[data-product-json]');
        const variantControl = section.querySelector('product-form [name="id"]');
        if (!pj || !variantControl || variantControl.value === '') return;
        let product;
        try {
          product = JSON.parse(pj.textContent);
        } catch (err) {
          return;
        }
        applyVariantMetafieldImages(variantControl.value, product.id);
      });
    } else {
      const variantControl = document.querySelector('product-form [name="id"]');
      if (!variantControl || variantControl.value === '') return;
      applyVariantMetafieldImages(variantControl.value, undefined);
    }
  }

  function rebuildSlideshowVariantImages(root, slides) {
    const slider = root.querySelector('[data-slider]');
    if (!slider) return;

    const sectionId = root.getAttribute('data-section-id') || '';
    const dHeight = root.getAttribute('data-slideshow-desktop-height') || '';
    const mHeight = root.getAttribute('data-slideshow-mobile-height') || '';
    // Pas de repli vedette produit en JS (décision theme — voir section-slideshow.liquid).
    const list = normalizeVariantSlideList(slides, '');

    if (!list.length) {
      destroySlideshowFlickity(slider);
      slider.classList.remove('flickity-enabled', 'flickity-rtl', 'is-initialized', 'single-slide', 'is-fade', 'is-loading');
      const jsRebuild = slider.dataset.slideshowVariantJsRebuild === 'true';
      const hadMarkup = slider.innerHTML && String(slider.innerHTML).trim() !== '';
      if (hadMarkup && !jsRebuild) {
        root.style.removeProperty('display');
        window.dispatchEvent(new Event('resize'));
        return;
      }
      delete slider.dataset.slideshowVariantJsRebuild;
      root.style.display = 'none';
      slider.innerHTML = '';
      window.dispatchEvent(new Event('resize'));
      return;
    }

    root.style.removeProperty('display');
    destroySlideshowFlickity(slider);

    slider.innerHTML = '';
    slider.classList.remove('flickity-enabled', 'flickity-rtl', 'is-initialized', 'single-slide', 'is-fade');
    slider.classList.add('is-loading');

    list.forEach((slidePair, idx) => {
      const html = buildSlideshowVariantSlideFromPair(slidePair, idx, sectionId, dHeight, mHeight, idx === 0);
      if (!html) return;
      const wrap = document.createElement('div');
      wrap.innerHTML = html.trim();
      const slide = wrap.firstElementChild;
      if (slide) slider.appendChild(slide);
    });
    if (slider.firstElementChild) {
      slider.dataset.slideshowVariantJsRebuild = 'true';
    }

    if (list.length <= 1) {
      slider.classList.add('single-slide');
      slider.classList.remove('is-loading');
      window.dispatchEvent(new Event('resize'));
      return;
    }

    slider.classList.remove('single-slide');

    const tv = window.themeVendor;
    if (!tv || !tv.Flickity) {
      slider.classList.remove('is-loading');
      return;
    }

    let customOptions = {};
    const optRaw = slider.getAttribute('data-options');
    if (optRaw) {
      try {
        customOptions = JSON.parse(optRaw);
      } catch (e) {
        customOptions = {};
      }
    }

    const { on: customOn, ...customRest } = customOptions;
    const customOnObj =
      customOn && typeof customOn === 'object' && !Array.isArray(customOn) ? customOn : {};
    const internalReady = function () {
      requestAnimationFrame(function () {
        slider.classList.add('is-initialized');
        slider.classList.remove('is-loading');
      });
    };
    const mergedOn = Object.assign({ ready: internalReady }, customOnObj);
    const userReady = customOnObj.ready;
    if (typeof userReady === 'function') {
      mergedOn.ready = function () {
        internalReady();
        userReady.call(this);
      };
    }
    const sliderOptions = Object.assign(
      {
        cellSelector: '[data-slide]',
        contain: true,
        wrapAround: true,
        adaptiveHeight: true,
        on: mergedOn,
      },
      customRest
    );

    try {
      if (customOptions.fade && tv.FlickityFade) {
        new tv.FlickityFade(slider, sliderOptions);
      } else {
        new tv.Flickity(slider, sliderOptions);
      }
    } catch (e) {
      slider.classList.remove('is-loading');
    }

    window.dispatchEvent(new Event('resize'));
  }

  /** Menu drawer mobile : niveau 1 en accordéon (reste sur la même vue) */
  function initMobileDrawerAccordion() {
    var DRAWER_MENU = '.drawer__menu';
    var ACCORDION = '.sliderule__wrapper--accordion';
    var TOGGLE = '.sliderow--accordion';

    function setExpanded(wrap, expanded) {
      var btn = wrap.querySelector(TOGGLE);
      var panel = wrap.querySelector('.mobile-nav__accordion-panel');
      wrap.classList.toggle('is-expanded', expanded);
      if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (panel) panel.hidden = !expanded;
    }

    function closeSiblingAccordions(menu, currentWrap) {
      var all = menu.querySelectorAll(ACCORDION);
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== currentWrap) setExpanded(all[i], false);
      }
    }

    function getVisibleDrawerMainMenu(drawer) {
      var menu = drawer.querySelector(DRAWER_MENU);
      if (!menu) return null;
      var desktop = menu.querySelector('.drawer__main-menu--desktop');
      var mobile = menu.querySelector('.drawer__main-menu--mobile');
      if (desktop && mobile) {
        if (window.matchMedia('(min-width: 750px)').matches) {
          return desktop;
        }
        return mobile;
      }
      return menu.querySelector('.drawer__main-menu') || menu;
    }

    function openFirstAccordionInDrawerHeader(drawer) {
      if (!drawer || !drawer.matches || !drawer.matches('.drawer--header')) return;
      var block = getVisibleDrawerMainMenu(drawer);
      if (!block) return;
      var accordions = block.querySelectorAll(ACCORDION);
      if (!accordions.length) return;
      for (var i = 0; i < accordions.length; i++) {
        setExpanded(accordions[i], i === 0);
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(DRAWER_MENU + ' ' + TOGGLE);
      if (!trigger) return;
      var wrap = trigger.closest(ACCORDION);
      if (!wrap) return;
      e.preventDefault();
      var expanded = wrap.classList.contains('is-expanded');
      if (!expanded) {
        var menu = wrap.closest(DRAWER_MENU);
        if (menu) closeSiblingAccordions(menu, wrap);
        setExpanded(wrap, true);
      } else {
        setExpanded(wrap, false);
      }
    });

    document.addEventListener('theme:drawer:open', function (e) {
      var t = e.target;
      if (t && t.nodeType === 1) {
        openFirstAccordionInDrawerHeader(t);
      }
    });

    document.addEventListener('theme:drawer:close', function () {
      document.querySelectorAll(DRAWER_MENU + ' ' + ACCORDION + '.is-expanded').forEach(function (w) {
        setExpanded(w, false);
      });
    });
  }

  /** ---------------------------------------------------------------------
   * 🚀 Initialisation sur DOM Ready
   * -------------------------------------------------------------------- */
  function runAfterVariantMetafieldInits() {
    initVariantMetafieldSlideshowAndHero();
    syncVariantMetafieldImagesFromForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initVariantDescriptionUpdater();
      initAccordionGroupVariantFaq();
      initProductVariantFaqExclusive();
      runAfterVariantMetafieldInits();
      initVariantImageUpdater();
      initVariantIconUpdater();
      initMobileDrawerAccordion();
    });
  } else {
    initVariantDescriptionUpdater();
    initAccordionGroupVariantFaq();
    initProductVariantFaqExclusive();
    runAfterVariantMetafieldInits();
    initVariantImageUpdater();
    initVariantIconUpdater();
    initMobileDrawerAccordion();
  }
})();
